"use strict";
module.exports = function(config, get){
	return {
		list: list,
		data: data,
		pages: pages
	};

	function list(){
		return get("/v2/org/tables/list");
	}

	function data(table, who, page, perPage, start, end, timezone){
		return get("/v2/org/tables/data", {
			table: table,
			who: who,
			page: page,
			perPage: perPage,
			start: start,
			end: end,
			timezone: timezone
		});
	}

	function pages(table, who, start, end, timezone){
		return get("/v2/org/tables/data/pages", {
			table: table,
			who: who,
			start: start,
			end: end,
			timezone: timezone
		});
	}
};
